import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

const WIDTH = 201;

export const GameInfoContainer = styled.div`
    ${BaseStyle.Mixins.gaps.medium}
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    padding-left: 0;
`;

export const InfoContainer = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body3}
    ${BaseStyle.Mixins.gaps.extraLarge}
    display: flex;
    align-items: flex-start;
    align-self: stretch;
`;

export const InfoCategory = styled.div`
    min-width: 124px;
    color: ${({ theme }) => theme.Text.secondary};
    text-transform: uppercase;
`;

export const GameInfoDetails = styled.div`
    max-width: ${WIDTH}px;
`;

export const OfficialsContainer = styled(GameInfoDetails)`
    display: flex;
    flex-direction: column;
`;

export const OfficialContainer = styled.div`
    display: flex;
`;
